// extracted by mini-css-extract-plugin
module.exports = {"modal__button":"modal__button-_P2A_","modal__button_decline":"modal__button_decline-2EnzM"};